import { createUseStyles } from 'react-jss';

import colors from "../../../../utils/colors";




var styles = {
  multiVariantsHeading: function multiVariantsHeading(_ref) {var variantsAmount = _ref.variantsAmount;return {
      position: 'relative',
      textTransform: 'initial',
      fontSize: '1.6rem',
      width: "".concat(34 * variantsAmount, "rem"),
      border: "0.1rem solid ".concat(colors.neutral[600]),
      borderBottom: "0.2rem solid ".concat(colors.neutral[600]),
      borderTop: 'none',
      padding: 0,
      '&:last-child': {
        borderRight: 'none'
      }
    };},
  nameWrapper: {
    padding: '1rem',
    paddingLeft: '2.5rem',
    alignItems: 'center',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
    display: 'flex',
    '& h2': {
      lineHeight: '5.6rem',
      fontSize: '1.8rem'
    }
  },
  variantsHeadings: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  portfolioLogo: {
    padding: '2rem',
    paddingLeft: '2.5rem',
    paddingBottom: 0,
    '& img': {
      height: '2.2rem'
    }
  },
  spinnerWrapper: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(255,255,255,0.8)',
    zIndex: 5
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map